import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/bi-events.js';
import { fireBIEvent2 } from 'public/bi-events.js';
import wixWindow from 'wix-window';

let formFactor = wixWindow.formFactor;

$w.onReady(function () {
    function event703(buttonNameVal, additionalInfoVal, targetUrlVal){
  const biFields = {
            button_name: buttonNameVal,
            additional_info: additionalInfoVal,
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: targetUrlVal,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    }
    //////////
    $w('#boxGetStarted').onClick(() => {
        event703($w('#getStarted').label, 'top fold',$w('#getStarted').link)
      
    })

    if (formFactor === "Mobile") {

        // --- Moibile --- //

        $w('#boxCreateBlog').onClick(() => {
            const biFields = {
                button_name: $w('#btnMobileCreateBlog').label,
                additional_info: 'third fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnMobileCreateBlog').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#boxCreateBlogB').onClick(() => {
            const biFields = {
                button_name: $w('#btnMobileCreateBlog2').label,
                additional_info: 'fourth fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnMobileCreateBlog2').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })
    } else {
        $w('#boxBuildIt').onClick(() => {
            const biFields = {
                button_name: $w('#buildItYour').label,
                additional_info: 'second fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#buildItYour').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#boxPowerful').onClick(() => {
            const biFields = {
                button_name: $w('#btnPowerful').label,
                additional_info: 'second fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnPowerful').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#boxDrive').onClick(() => {
            const biFields = {
                button_name: $w('#btnDrive').label,
                additional_info: 'second fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnDrive').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#boxEarn').onClick(() => {
            const biFields = {
                button_name: $w('#btnEarn').label,
                additional_info: 'second fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnEarn').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#boxMange').onClick(() => {
            const biFields = {
                button_name: $w('#btnMange').label,
                additional_info: 'second fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnMange').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#boxPlan').onClick(() => {
            const biFields = {
                button_name: $w('#btnPlan').label,
                additional_info: 'second fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnPlan').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        // $w('#boxPlan').onClick(() => {
        //     const biFields = {
        //         button_name: $w('#btnPlan').label,
        //         additional_info: 'second fold',
        //         topic: 'blog gate',
        //         url: wixLocation.url,
        //         targetUrl: $w('#btnPlan').link,
        //         is_valid: true,
        //     }
        //     fireBIEvent(19, 703, biFields);
        // })

        $w('#boxCreateBlog').onClick(() => {
            const biFields = {
                button_name: $w('#btnCreateBlog').label,
                additional_info: 'third fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnCreateBlog').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#boxCreateBlogB').onClick(() => {
            const biFields = {
                button_name: $w('#btnCreateBlogB').label,
                additional_info: 'fourth fold',
                topic: 'blog gate',
                url: wixLocation.url,
                targetUrl: $w('#btnCreateBlogB').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })
    }

    $w('#boxDriveTraffic').onClick(() => {
        const biFields = {
            button_name: $w('#btnDriveTraffic').label,
            additional_info: 'fifth fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#btnDriveTraffic').link,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    $w('#boxCreateBlogC').onClick(() => {
        const biFields = {
            button_name: $w('#btnCreateBlogC').label,
            additional_info: 'sixth fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#btnCreateBlogC').link,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    $w('#boxCreateBlogD').onClick(() => {
        const biFields = {
            button_name: $w('#btnCreateBlogD').label,
            additional_info: 'seventh fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#btnCreateBlogD').link,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    $w('#boxCreateBlogE').onClick(() => {
        const biFields = {
            button_name: $w('#btnCreateBlogE').label,
            additional_info: 'eighth fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#btnCreateBlogE').link,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    $w('#boxReadLeft').onClick(() => {
        const biFields = {
            button_name: "Read More Left", //$w('#btnReadLeft').label,
            additional_info: 'ninth fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#text355').text,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    $w('#boxReadMiddle').onClick(() => {
        const biFields = {
            button_name: "Read More Middle", //$w('#btnReadMiddle').label,
            additional_info: 'ninth fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#text356').text,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    $w('#boxReadRight').onClick(() => {
        const biFields = {
            button_name:"Read More Right", //$w('#btnReadRight').label,
            additional_info: 'ninth fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#text358').text,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    $w('#boxCreateBlogF').onClick(() => {
        const biFields = {
            button_name: $w('#btnCreateBlogF').label,
            additional_info: 'bottom fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#btnCreateBlogF').link,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

     $w('#boxCreateBlogG').onClick(() => {
        const biFields = {
            button_name: $w('#btnCreateBlogG').label,
            additional_info: 'tenth fold',
            topic: 'blog gate',
            url: wixLocation.url,
            targetUrl: $w('#btnCreateBlogG').link,
            is_valid: true,
        }
        fireBIEvent(19, 703, biFields);
    })

    

    $w('#text354').onViewportEnter(() => {
        console.log('enter scroll to bottom');
        fireBIEvent2(19, 125102, { lp_name: 'blog gate' });
    })
});